import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onChangeData: (arg1: number, arg2: number) => void;
  labelFilterDefault?: string;
  disabledFilter: boolean;
};

export const SelectFilterData = ({ onChangeData, labelFilterDefault, disabledFilter }: Props) => {
  const { t } = useTranslation();
  const date = new Date();
  const year = date.getFullYear();

  const options = [
    {
      value: 0,
      optionLabel: 'new_annual_total',
    },
    {
      value: 1,
      optionLabel: 'january',
    },
    {
      value: 2,
      optionLabel: 'february',
    },
    {
      value: 3,
      optionLabel: 'march',
    },
    {
      value: 4,
      optionLabel: 'april',
    },
    {
      value: 5,
      optionLabel: 'may',
    },
    {
      value: 6,
      optionLabel: 'june',
    },
    {
      value: 7,
      optionLabel: 'july',
    },
    {
      value: 8,
      optionLabel: 'august',
    },
    {
      value: 9,
      optionLabel: 'september',
    },
    {
      value: 10,
      optionLabel: 'october',
    },
    {
      value: 11,
      optionLabel: 'november',
    },
    {
      value: 12,
      optionLabel: 'december',
    },
    {
      value: 13,
      optionLabel: 'new_first_trimester',
    },
    {
      value: 14,
      optionLabel: 'new_second_trimester',
    },
    {
      value: 15,
      optionLabel: 'new_third_trimester',
    },
    {
      value: 16,
      optionLabel: 'new_fourth_trimester',
    },
  ];

  const onChangeDataFilter = e => {
    onChangeData(Number(e.target.value), year);
  };

  return (
    <div className="select-filter-container">
      <span className="select-filter-label">{t('content_manager_delegations_filters')}:</span>
      <select
        value={labelFilterDefault}
        className={'custom-select'}
        onChange={e => onChangeDataFilter(e)}
        disabled={disabledFilter}
      >
        {options &&
          options.map(option => (
            <option key={option.value} value={option.value}>
              {t(option.optionLabel)}
            </option>
          ))}
      </select>
    </div>
  );
};
